export  const  getToken = () =>{
  const { accessToken } = JSON.parse(localStorage.getItem("stt")) || {};
  return accessToken;
};

export  const  getProjectToken = () =>{
  const { accessToken } = JSON.parse(localStorage.getItem("project_token")) || {};
  return accessToken;
};
